import { Card, CardBody, CardHeader, CardHeading, FormattedCurrency } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { DetailsPageInfoField } from "../../../../shared/ui/DetailsPageInfoField";
import { EventDetailResource } from "../../shared/types";

const StyledCardBody = styled(CardBody)`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-gap: ${({ theme }) => theme.spacing(5)};
`;

interface Props {
	event: EventDetailResource;
}

export const EventCostsCard: FC<Props> = ({ event }) => {
	const { t } = useTranslation();

	return (
		<Card>
			<CardHeader>
				<CardHeading>{t("Costs")}</CardHeading>
			</CardHeader>
			<StyledCardBody>
				<DetailsPageInfoField
					title={t("Total planned costs")}
					value={
						event.totalPlannedCosts && event.currency ? (
							<FormattedCurrency value={event.totalPlannedCosts} currencyType={event.currency} />
						) : (
							"-"
						)
					}
				/>
				<DetailsPageInfoField
					title={t("Total actual costs")}
					value={
						event.totalActualCosts && event.currency ? (
							<FormattedCurrency value={event.totalActualCosts} currencyType={event.currency} />
						) : (
							"-"
						)
					}
				/>
				<DetailsPageInfoField
					title={t("Individual costs")}
					value={
						event.individualCosts && event.currency ? (
							<FormattedCurrency value={event.individualCosts} currencyType={event.currency} />
						) : (
							"-"
						)
					}
				/>
			</StyledCardBody>
		</Card>
	);
};
